module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOAQMAAAAc4Q7JAAAABlBMVEUAAABZYGoOkE8RAAAAAXRSTlMAQObYZgAAABBJREFUCNdj+HwegYAANxcAvAkVGVjy4vwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_board.png
// module id = 0JMw
// module chunks = 9